import { isProd } from "@/config/common";
import {
  ContentfulLocaleEnum,
  CountryCodeEnum,
  CountryNameEnum,
  CurrencyCodeEnum,
  DomainEnum,
  ElevateCodeEnum,
  LanguageCodeEnum,
  type Market,
  PSPEnum,
  SiteLocaleEnum,
  SiteNameEnum,
} from "./i18n-config";

export const cz: Market = {
  psp: PSPEnum.ADYEN,
  flag: "🇨🇿",
  currency: CurrencyCodeEnum.EUR,
  countryCode: CountryCodeEnum.CZ,
  countryName: CountryNameEnum.CZ,
  languageCode: LanguageCodeEnum.EN,
  locale: `${LanguageCodeEnum.EN}-${CountryCodeEnum.CZ}`,
  upperCaseLocale: `${LanguageCodeEnum.EN}-${CountryCodeEnum.CZ.toUpperCase()}`,
  contentfulLocale: ContentfulLocaleEnum.EU,
  siteLocale: SiteLocaleEnum.CZ,
  elevateMarket: ElevateCodeEnum.EU,
  externalStoreId: "ecom-noga",
  searchPathName: "/search",
  domain: DomainEnum.NOGA,
  imageCdn: isProd()
    ? "https://cdn.no-ga.com"
    : "https://media.stage.cdn-norce.tech/1413",
  siteName: SiteNameEnum.EU,
};
